/**
 * Whether the view switched to a different chat, so per-chat local state must be reset. Switching
 * chats doesn't unmount ChatPage, so this is the only signal.
 */
export function isChatSwitch({
  previousChatId,
  chatId,
  storeChatId,
  hasTrackedChatId,
}: {
  previousChatId: string | undefined;
  chatId: string | undefined;
  storeChatId: string | undefined;
  /** False until the first render has recorded a chat id, so mounting is not a switch. */
  hasTrackedChatId: boolean;
}): boolean {
  if (!hasTrackedChatId) return false;
  if (previousChatId === chatId) return false;

  // Draft becoming a real chat isn't a switch — keep its prompt, attachments and messages.
  const isDraftPromotion = !previousChatId && !!chatId && chatId === storeChatId;

  // Same when `disableStoreChatId` turns on (e.g. a case was linked in the new-chat page).
  const isStoreChatIdIntentionallyDropped = !!previousChatId && !chatId && previousChatId === storeChatId;

  return !isDraftPromotion && !isStoreChatIdIntentionallyDropped;
}

/**
 * Whether a chat switch should clear the opened chat's cached messages. Only the shared draft
 * bucket is cleared. A real chat keeps its cache: hydration already ran, and a cached RTK Query
 * response won't trigger it again, so clearing would leave the chat empty.
 */
export function shouldClearCachedMessages(chatId: string | undefined): boolean {
  return !chatId;
}
